export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./aggregator-settings.vue?vue&type=template&id=4c549fe9&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/aggregator-settings.vue?vue&type=template&id=4c549fe9&scoped=true
// module id = kc0T
// module chunks = 0